import Cookies from 'js-cookie';

import getEnvironmentVariables from '@/server/utils/getEnvironmentVars';

export const addEnvName = (cookieName: string) => {
  const envVars = getEnvironmentVariables(['NEXT_PUBLIC_APP_ENV']);

  if (envVars.isErr()) {
    console.info('Error fetching environment variables:', envVars.error);
  }

  return envVars.isOk() && envVars.value.NEXT_PUBLIC_APP_ENV !== 'prod'
    ? `${envVars.value.NEXT_PUBLIC_APP_ENV}-${cookieName}`
    : cookieName;
};

export const ACCESS_TOKEN_COOKIE_NAME = addEnvName('access_token');
export const LEGACY_MYOMERS_ACCESS_TOKEN_COOKIE_NAME = addEnvName('timed-access-token');
export const MEMBERSHIP_NO_COOKIE_NAME = addEnvName('membershipNo');
export const SHOW_USER_SIGNED_IN_COOKIE_NAME = addEnvName('show-user-signed-in');
export const REGISTRATION_PRE_MFA_TOKEN_COOKIE_NAME = addEnvName('registration_pre_mfa_token');
export const REGISTRATION_MFA_TOKEN_COOKIE_NAME = addEnvName('registration_mfa_token');
export const FORGOT_FLOW_PRE_MFA_TOKEN_COOKIE_NAME = addEnvName('forgot_flow_pre_mfa_token');
export const FORGOT_FLOW_MFA_TOKEN_COOKIE_NAME = addEnvName('forgot_flow_mfa_token');
export const NOTICE_PREFERENCES = addEnvName('notice_preferences');
export const SESSION_EXTENDED_AT = addEnvName('session-extended-at');

export const cleanupCookies = () => {
  const cookiesToClean = [
    ACCESS_TOKEN_COOKIE_NAME,
    LEGACY_MYOMERS_ACCESS_TOKEN_COOKIE_NAME,
    SHOW_USER_SIGNED_IN_COOKIE_NAME,
    MEMBERSHIP_NO_COOKIE_NAME,
    SESSION_EXTENDED_AT
  ];

  cookiesToClean.forEach((cookieName) => {
    Cookies.remove(cookieName, {
      domain: '.omers.com',
      sameSite: 'lax'
    });
  });
};
